import Plugin from '../core/Plugin';

/**
 * PageViewPlugin - Handles page view mode toggle
 */
class PageViewPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'PageView';
  }

  getToolbarButtons() {
    return [
      {
        name: 'view',
        buttons: [{ command: 'togglePageView', label: '📄', title: 'Toggle Page View' }],
      },
    ];
  }

  executeCommand(command) {
    if (command === 'togglePageView') {
      this.editor.togglePageView();
    }
  }

  getMetadata() {
    return {
      name: 'Page View',
      version: '1.0.0',
      description: 'Provides page view mode (8.5" x 11" paper)',
      author: 'AtlaraFirm',
    };
  }
}

export default PageViewPlugin;
